var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDocs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 20,
    viewBox: "0 0 28 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 5V13C5 14.1046 5.89543 15 7 15H13M5 5V3C5 1.89543 5.89543 1 7 1H11.5858C11.851 1 12.1054 1.10536 12.2929 1.29289L16.7071 5.70711C16.8946 5.89464 17 6.149 17 6.41421V13C17 14.1046 16.1046 15 15 15H13M5 5H3C1.89543 5 1 5.89543 1 7V17C1 18.1046 1.89543 19 3 19H11C12.1046 19 13 18.1046 13 17V15",
    stroke: "#8C3B5E",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocs);
export default __webpack_public_path__ + "static/media/docs.7c2692bbd679915eeba15a7199d609e0.svg";
export { ForwardRef as ReactComponent };